document.querySelectorAll(".ptw-title-wrap .ptw-title").forEach((item) => {
  item.addEventListener("click", function () {
    // Corrected typo here
    removeActiveClass();
    item.classList.add("active");
    const tabname = item.dataset.title;
    document
      .querySelectorAll(
        `.ptw-text-wrap .ptw-content-wrap[data-title="${tabname}"]`
      )
      .forEach((contentItem) => {
        contentItem.classList.add("active");
      });
  });
});

const atcBUtton = document.querySelector(".piw-continue-btn button");
if (atcBUtton) {
  atcBUtton.addEventListener("click", async function () {
    atcBUtton.classList.add("loading");
    
    const commanfaults = [];
    document.querySelectorAll('.issue-list-wrap input:checked').forEach(fault => {
       if(fault.value != 'Other'){
         commanfaults.push(fault.value);    
       }else{
           const otherissue = document.querySelector('.other-issue-input input[type="text"]')?.value;
           if(otherissue != ''){commanfaults.push(otherissue);}
       }
    });
    
    const commonfaultinput = document.querySelectorAll('.issue-list-wrap input');
    if(commanfaults.length == 0 && commonfaultinput.length > 0){
      document.querySelector('.issue-list-wrap').classList.add('error');
      atcBUtton.classList.remove("loading");
      return true;
    }
    const commaSeparatedText = commanfaults.join(', ');

    const otherCommanFault = document.querySelector('.issue-list-wrap label.other-checkbox input:checked');
    const otherissue = document.querySelector('.other-issue-input input[type="text"]')?.value;
    if(otherCommanFault && otherissue == ''){
      document.querySelector('.other-issue-input').classList.add('error');
      atcBUtton.classList.remove("loading");
      return true;
    }

    const defaultaddress = customer.default_address;
    // if(!defaultaddress.address1 || !defaultaddress.city || !defaultaddress.company || !defaultaddress.phone || !defaultaddress.province || !defaultaddress.zip ){
    //   document.querySelector('.address-note').style.display = 'block';
    //   atcBUtton.classList.remove("loading");
    //   console.log('address not added');
    //   return true;
    // }
    
    const clearReq = await fetch("/cart/clear.js");
    const clearRes = await clearReq.json();
    const vid = this.dataset.vid;
    let formData = {
      items: [{ id: vid, quantity: 1, properties: { __main_product: true, __common_faults: commaSeparatedText } }],
    };
    const diagnosticFee = document.querySelector(
      "input#testing-and-diagnostic-fee"
    )?.value;
    if (diagnosticFee) {
      formData.items.push({
        id: diagnosticFee,
        quantity: 1,
        properties: { __testing_and_diagnostic_fee: true },
      });
    }
    const postagefee = document.querySelector("input#postage-fee")?.value;
    if (postagefee) {
      formData.items.push({
        id: postagefee,
        quantity: 1,
        properties: { __postage_fee: true },
      });
    }
    document.querySelectorAll("input#extra-part-product").forEach((part) => {
      formData.items.push({
        id: part.value,
        quantity: 1,
        properties: { __extra_part: true },
      });
    });
    console.log("formData ", formData);
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log("response ", response);
        atcBUtton.classList.remove("loading");
        window.location.href = "/pages/checkout";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
}

/* remove error for command faults */

document.querySelectorAll('.issue-list-wrap input[type="checkbox"]').forEach(input => {
   input.addEventListener('change', function(){
       this.closest('.issue-list-wrap').classList.remove('error');
   });
});
document.querySelectorAll('.issue-list-wrap input[type="text"]').forEach(input => {
   input.addEventListener('keyup', function(){
       this.closest('.issue-list-wrap').classList.remove('error');
       document.querySelector('.other-issue-input').classList.remove('error');
   });
});

const removeActiveClass = () => {
  // Removed unused parameter 'classs'
  document.querySelectorAll(".ptw-title-wrap .ptw-title").forEach((item) => {
    item.classList.remove("active");
  });
  document
    .querySelectorAll(".ptw-text-wrap .ptw-content-wrap")
    .forEach((item) => {
      item.classList.remove("active");
    });
};

/* replace retuen to url on login page */
const pathname = window.location.pathname;
if(pathname.indexOf('/account') == -1){
    const returnUrl = window.location.href; // Capture the current URL
    localStorage.setItem('returnURL', returnUrl); // Store it in local storage
}
const returnInput = document.querySelector('input[name="return_to"]');
const returnUrl = localStorage.getItem('returnURL');
if (returnInput && returnUrl) {
  document.querySelector('input[name="return_to"]').value = returnUrl;
}

/* featured collection tab section start */
document.querySelectorAll(".fct-button-wrap button").forEach((button) => {
  button.addEventListener("click", function () {
    document.querySelector(".fct-button-wrap button.active").classList.remove("active");
    this.classList.add("active");
    const tabhandle = this.dataset.handle;
    const url = `/collections/${tabhandle}?view=featured-collection-tab`;
    scrollToFilterSection();
    getFeaturedCollection(url);
  });
});

function getFeaturedCollection(endpoint) {
  document.querySelector(".fct-collection-main.active").classList.add('loading');
  fetch(endpoint)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      document.querySelector(".fct-collection-main.active .fct-collection-products").innerHTML = doc.querySelector('.fct-collection-products').innerHTML;
      document.querySelector(".fct-collection-main.active .cataloge-search-filters").innerHTML = doc.querySelector('.cataloge-search-filters')?.innerHTML;
      document.querySelector(".fct-collection-main.active .fct-tab-sorting").innerHTML = doc.querySelector('.fct-tab-sorting')?.innerHTML;
      document.querySelector(".fct-collection-main.active").classList.remove('loading');
      
    })
    .catch((error) => {
      console.error("Error fetching the HTML:", error);
    });
}

function scrollToFilterSection(){
  const element = document.querySelector('.fct-collection-main');
  const offset = 10; // Set the offset value
  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - offset;
  window.scrollTo({top: offsetPosition,behavior: 'smooth'});
}

document.querySelectorAll(".fct-button-wrap button.active").forEach((item) => {
  const tabhandle = item.dataset.handle;
  const url = `/collections/${tabhandle}?view=featured-collection-tab`;
  getFeaturedCollection(url);
});

function homeFilterAccordian(item) {
  item.closest(".fcf-filter-wrap").classList.toggle("actove");
}

function tabFilter(item) {
  const sortBy = document.querySelector('.fct-sort-list li.active').getAttribute('data-value');
  const handle = document.querySelector('.fct-tab-wrapper .fct-button-wrap button.active').getAttribute('data-handle');
  let url = `/collections/${handle}?view=featured-collection-tab&sort_by=${sortBy}`;
  item
    .closest(".cataloge-search-filters")
    .querySelectorAll("input:checked")
    .forEach((input) => {
      const name = input.getAttribute("name"),
        val = input.value;
      url += `&${name}=${val}`;
    });
  console.log("url ", url);
  getFeaturedCollection(url);
}

function sortHideShow(item){
  item.closest('.fct-tab-sorting').querySelector('.fct-sort-list').classList.toggle('show'); 
}

function sortCollection(sortvalue){
  const handle = document.querySelector('.fct-tab-wrapper .fct-button-wrap button.active').getAttribute('data-handle');
  let url = `/collections/${handle}?view=featured-collection-tab&sort_by=${sortvalue}`;
  document.querySelectorAll('.cataloge-search-filters input:checked').forEach((input) => {
      const name = input.getAttribute("name"),
        val = input.value;
      url += `&${name}=${val}`;
    });
  console.log("url ", url);
  getFeaturedCollection(url);
}

function searchInSpecificCollection(item){
  const handle = document.querySelector('.fct-tab-wrapper .fct-button-wrap button.active').getAttribute('data-handle');
  if(item.value.length > 4){
    const sortBy = document.querySelector('.fct-sort-list li.active').getAttribute('data-value');
    let url = `/collections/${handle}?view=featured-collection-tab&sort_by=${sortBy}`;
    document.querySelectorAll('.cataloge-search-filters input:checked').forEach((input) => {
        const name = input.getAttribute("name"),
          val = input.value;
        url += `&${name}=${val}`;
      });
     url += `&searchquery=${item.value}`;
    getFeaturedCollection(url);
  }else if(item.value.length == 0){
    const sortBy = document.querySelector('.fct-sort-list li.active').getAttribute('data-value');
    let url = `/collections/${handle}?view=featured-collection-tab&sort_by=${sortBy}`;
    document.querySelectorAll('.cataloge-search-filters input:checked').forEach((input) => {
        const name = input.getAttribute("name"),
          val = input.value;
        url += `&${name}=${val}`;
      });
    getFeaturedCollection(url);
  }
}

document.addEventListener('click', function(event) {
    const popup = document.querySelector('.fct-sort-list');
    const showPopupBtn = document.querySelector('.fct-tab-sorting button');
    if (!popup?.contains(event.target) && event.target !== showPopupBtn) {
        popup?.classList.remove('show');
    }
});

/* featured collection tab section end */

window.clearCart = () => {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Cart cleared successfully.");
    })
    .catch((error) => {
      console.error("Error clearing the cart:", error);
    });
};

document
  .querySelector(".technical-bulletins-box select")
  ?.addEventListener("change", function () {
    const vehicleMake = this.value;
    console.log("vehicleMake ", vehicleMake);
    document
      .querySelector(`.tbr-block-bulletin.show`)
      ?.classList?.remove("show");
    document
      .querySelector(`.tbr-block-bulletin[data-handle="${vehicleMake}"]`)
      .classList.add("show");
  });

document
  .querySelector(".blog-filter select")
  ?.addEventListener("change", function () {
    const categorieurl = this.value;
    window.location.href = categorieurl;
  });

/* resources videos js start */
document
  .querySelectorAll(".rvw-sidebar li.rvw-sidebar-item")
  .forEach((item) => {
    item.addEventListener("click", function () {
      document
        .querySelector(".rvw-sidebar li.rvw-sidebar-item.active")
        .classList.remove("active");
      document
        .querySelector(".rvw-content-grid-item.active")
        .classList.remove("active");
      this.classList.add("active");
      const handle = this.dataset.handle;
      document
        .querySelector(`.rvw-content-grid-item[data-handle="${handle}"]`)
        .classList.add("active");
    });
  });
document
  .querySelectorAll(
    ".rvw-videos-content .rvw-content-item .rvw-content-image img"
  )
  .forEach((item) => {
    item.addEventListener("click", function () {
      this.closest(".rvw-content-item")
        .querySelector(".rvw-video-popup")
        .classList.add("active");
      document.querySelector(".rvw-videos-overflow").classList.add("active");
    });
  });
document
  .querySelectorAll(
    ".rvw-videos-content .rvw-content-item button.button.play-btn"
  )
  .forEach((item) => {
    item.addEventListener("click", function () {
      this.closest(".rvw-content-item")
        .querySelector(".rvw-video-popup")
        .classList.add("active");
      document.querySelector(".rvw-videos-overflow").classList.add("active");
    });
  });
document
  .querySelectorAll(".rvw-videos-content .rvw-content-item .rcw-close")
  .forEach((item) => {
    item.addEventListener("click", function () {
      const videosrc = document.querySelector(".rvw-video-popup.active").dataset
        .url;
      document
        .querySelector(".rvw-video-popup.active iframe")
        .setAttribute("src", videosrc);
      this.closest(".rvw-content-item")
        .querySelector(".rvw-video-popup")
        .classList.remove("active");
      document.querySelector(".rvw-videos-overflow").classList.remove("active");
    });
  });
document.querySelectorAll(".rvw-videos-overflow").forEach((item) => {
  item.addEventListener("click", function () {
    const videosrc = document.querySelector(".rvw-video-popup.active").dataset
      .url;
    document
      .querySelector(".rvw-video-popup.active ifrane")
      .setAttribute("src", videosrc);
    document
      .querySelector(".rvw-video-popup.active")
      .classList.remove("active");
    document.querySelector(".rvw-videos-overflow").classList.remove("active");
  });
});
/* resources videos js end */

/* custom-repair add to cart */
async function crnfatc(crnbtn) {
  crnbtn.classList.add("loading");
  const clearReq = await fetch("/cart/clear.js");
  const clearRes = await clearReq.json();
  const vid = crnbtn.dataset.id;
  const login = crnbtn.dataset.customer;
  if (login == "true") {
    let formData = {
      items: [{ id: vid, quantity: 1, properties: { __custom_repair: true } }],
    };
    // if (window.postage.available) {
    //   formData.items.push({
    //     id: window.postage.vid,
    //     quantity: 1,
    //     properties: { __postage_fee: true },
    //   });
    // }
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        crnbtn.classList.remove("loading");
        window.location.href = "/pages/book-a-repair";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } else {
    window.location = "/account/login";
  }
}

/* geting excel sheet data */
if (window.excel.fileUrl) {
  fetch(window.excel.fileUrl)
    .then((response) => response.arrayBuffer())
    .then((data) => {
      const workbook = XLSX.read(new Uint8Array(data), { type: "array" });

      // Assuming the first sheet in the workbook
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Convert the sheet to JSON
      const exceljson = XLSX.utils.sheet_to_json(worksheet);
      window.excel.fileJson = exceljson;
    })
    .catch((error) =>
      console.error("Error fetching or processing the Excel file:", error)
    );
}

/* catagelog filter */

function csFilter(item, index) {
  let filterQuery = `&sort_by=title-ascending&filterindex=${index}`;
  const csSelects = item
    .closest(".cataloge-search-wrapper")
    .querySelectorAll(".cataloge-search-filters select");
    csSelects.forEach((select) => {
      const selectedOption = select.options[select.selectedIndex];
      const value = selectedOption.value;
      const dataName = selectedOption.getAttribute("data-name");
      if(value == 'all'){
        select.querySelectorAll('option[data-name]').forEach(alloption => {
          const all_value = alloption.value;
          const all_data_name = alloption.getAttribute("data-name");
          filterQuery += `&${all_data_name}=${all_value}`;
        });
      }else if(value) {
        filterQuery += `&${dataName}=${value}`;
      }
    });
   const manufacturerValue = item.closest(".cataloge-search-wrapper")
    .querySelector(".cataloge-search-filters select.manufacturer").value.toLowerCase();

    const handleizedValue = manufacturerValue
        .trim()                        
        .toLowerCase()                    
        .replace(/[\s\W-]+/g, '-')        
        .replace(/^-+|-+$/g, '');
    
    console.log(handleizedValue);
   console.log("filterQuery ", filterQuery);
  if (csSelects.length > index) {
    fetch(`${location.origin}/collections/${handleizedValue}?view=catalogue-filter${filterQuery}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        item.closest(".cataloge-search-wrapper").querySelector('.other-filter').innerHTML = doc.querySelector('.other-filter').innerHTML;;
      })
      .catch((error) => {
        console.error("Error fetching the HTML:", error);
      });
  }
}
function csSearch(item) {
  let filterQuery = `&sort_by=title-ascending`;
  const csSelects = item
    .closest(".cataloge-search-wrapper")
    .querySelectorAll(".cataloge-search-filters select");
  let csFilterCount = 0;
  csSelects.forEach((select) => {
    const selectedOption = select.options[select.selectedIndex];
    const value = selectedOption.value;
    const dataName = selectedOption.getAttribute("data-name");
    const dataEmpty = selectedOption.getAttribute("data-empty");
    if (value || dataEmpty) {
      filterQuery += `&${dataName}=${value}`;
      csFilterCount += 1;
    }
  });
  console.log("filterQuery ", filterQuery);
  console.log("csFilterCount ", csFilterCount);
  console.log("csSelects.length ", csSelects.length);
  const squery = document.querySelector(".cataloge-search-filters select.manufacturer").value;
  window.location.href = `${location.origin}/search?q=${squery}${filterQuery}`;
  // if (csSelects.length == csFilterCount) {
  //   const squery = document.querySelector(".cataloge-search-filters select.manufacturer").value;
  //   window.location.href = `${location.origin}/search?q=${squery}${filterQuery}`;
  // }
}
function csClear(item){
  const csSelects = item
    .closest(".cataloge-search-wrapper")
    .querySelectorAll(".cataloge-search-filters select");
  let csFilterCount = 0;
  csSelects.forEach((select) => {
    const selectedOption = select.options[select.selectedIndex];
    const value = selectedOption.value;
    if(value){csFilterCount+=1;}
  });
  console.log('csFilterCount ',csFilterCount);
  if(csFilterCount > 0){
    fetch(`${location.origin}/collections/all?view=catalogue-filter`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        item.closest(".cataloge-search-wrapper").querySelector('.cataloge-search-filters').innerHTML = doc.querySelector('.cataloge-search-filters').innerHTML;;
      })
      .catch((error) => {
        console.error("Error fetching the HTML:", error);
      });
  }
}
/* end catagelog filter */

/* custom-repair add to cart end here */

function printpage() {
  window.print();
}

document.querySelector('.other-customer-details input#other-customer')?.addEventListener('change', function(){
   if(this.checked){
       document.querySelector('.other-customer-details .shipping-address-wrapper').style.display = 'block';
   }else{
       document.querySelector('.other-customer-details .shipping-address-wrapper').style.display = 'none';
   }
});

document.querySelectorAll('.product .product__info-wrapper .form-item.other-checkbox input').forEach(item => {
   item.addEventListener('change', function(){
      console.log('checked ', this.checked);
      if(this.checked){
          document.querySelector('.product .product__info-wrapper label.form-item.other-issue-input')?.classList.add('active');
      }else{
          document.querySelector('.product .product__info-wrapper label.form-item.other-issue-input')?.classList.remove('active');
      }
      document.querySelector('.other-issue-input').classList.remove('error');
   });
});

$(".wwss-image-slider").slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  asNavFor: ".wwss-content-slider",
});
$(".wwss-content-slider").slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  asNavFor: ".wwss-image-slider",
});

// change tab on collection lists click

document.querySelectorAll('.tab__collection-list a').forEach(item => {
   item.addEventListener('click', function(e){
       e.preventDefault();
       const index = this.closest('.tab__collection-list').dataset.index;
       document.querySelector('.tab__collection-list.active').classList.remove('active');
       this.closest('.tab__collection-list').classList.add('active');
       document.querySelector(`.fct-tab-wrapper .fct-button-wrap button[data-index="${index}"]`)?.click();
   });
});

document.querySelectorAll('.ptw-content-wrap.view-more-active .view-btn-wrap button').forEach(item => {
    item.addEventListener('click', function() {
        const btnType = this.classList.contains('view-more');
        console.log('btn type', btnType);
        if(btnType){
            this.closest('.ptw-content').classList.add('show-all-list');
        }else{
            this.closest('.ptw-content').classList.remove('show-all-list');
        }
    });
});

/* register page js */
document.querySelectorAll('input#RegisterForm-marketing-email,input#RegisterForm-marketing-sms').forEach(input => {
   input.addEventListener('change', function(){
       let tags = '';
       document.querySelectorAll('input#RegisterForm-marketing-email:checked,input#RegisterForm-marketing-sms:checked').forEach(item => {
           const ctag = this.dataset.tag;
           if(tags == ''){tags = ctag;}else{tags += ','+ctag;}
       });
       const inputElement = document.querySelector('input#customer_tags');
      if (inputElement) {
          inputElement.value = tags;
      }
   });
});

document.querySelector('.wdbd-wrapper select')?.addEventListener('change', function(){
   const value = this.value;
    console.log('value ',value);
    if(value == 'Other'){
        document.querySelector('.what-does-business-do-other').style.display = 'block';
        document.querySelector('.what-does-business-do-other').innerHTML = '<input type="text" id="other-business" name="customer[note][Other Business Work]" placeholder="Other Business Work" required /><label for="other-business">Other Business Work*</label>'
    }else{
        document.querySelector('.what-does-business-do-other').innerHTML = '';
        document.querySelector('.what-does-business-do-other').style.display = 'none';
    }
});

document.querySelectorAll('.search-collection-list a').forEach(item => {
   item.addEventListener('click', function(){
       console.log('asasas');
       window.location.href = this.getAttribute('href'); 
   });
});
